<template>
  <!-- Dashboard Content
	================================================== -->
  <div class="dashboard-content-container" data-simplebar>
    <div class="dashboard-content-inner">
      <!-- Dashboard Headline -->
      <div class="dashboard-headline">
        <h3>Create a new Project</h3>

        <!-- Breadcrumbs -->
        <nav id="breadcrumbs" class="dark">
          <ul>
            <li><a href="#">Home</a></li>
            <li><a href="#">Dashboard</a></li>
            <li>Create a new Project</li>
          </ul>
        </nav>
      </div> 

      <!-- Row -->
      <div class="row">
        <!-- Dashboard Box -->
        <div class="col-xl-12">
          <div class="dashboard-box margin-top-0">
            <!-- Headline -->
            <div class="headline">
              <h3>
                <i class="icon-feather-folder-plus"></i> Project Creation Form
              </h3>
            </div>
<keep-alive>
            <div class="content with-padding padding-bottom-10">
              <div class="row">
                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Project Title</h5>
                    <input
                      type="text"
                      class="with-border"
                      v-model="projectRequest.title"
                    />
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Project Model</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select
                          title="Select Project Model"
                          v-model="projectRequest.model"
                          @change="changeModel($event)"
                        >
                          <option :value="null" selected disabled hidden>
                            Select option
                          </option>
                          <option
                            v-for="(model, index) in models"
                            :key="index"
                            :value="index"
                          >
                            {{ model }}
                          </option>
                        </select>
                      </div>
                      <i class="icon-feather-chevron-down"></i>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Task Category</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select
                          title="Select Task Category"
                          v-model="projectRequest.task_id"
                        >
                          <option :value="null" selected disabled hidden>
                            Select option
                          </option>
                          <option
                            v-for="task in tasks"
                            :key="task.id"
                            :value="task.id"
                          >
                            {{ task.name }}
                          </option>
                        </select>
                      </div>
                      <i class="icon-feather-chevron-down"></i>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Sub-Task Category</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select
                          title="Select Sub-Task Category"
                          @change="getSubTasks()"
                          v-model="projectRequest.sub_task_id"
                        >
                          <option :value="null" selected disabled hidden>
                            Select option
                          </option>
                          <option
                            v-for="task in tasks"
                            :key="task.id"
                            :value="task.id"
                          >
                            {{ task.name }}
                          </option>
                        </select>
                      </div>
                      <i class="icon-feather-chevron-down"></i>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Number of Task Masters</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select
                          title="Select Project Model"
                          v-model="projectRequest.num_of_taskMaster"
                        >
                          <option :value="null" selected disabled hidden>
                            Select option
                          </option>
                          <option
                            v-for="num in numOfTaskMasters"
                            :key="num"
                            :value="num"
                          >
                            {{ num }}
                          </option>
                        </select>
                      </div>
                      <i class="icon-feather-chevron-down"></i>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4" v-if="!isRemote">
                  <div class="submit-field">
                    <h5>Country</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select
                          title="Select Project Model"
                          @change="getCountryId($event)"
                          v-model="projectRequest.country_id"
                        >
                          <option :value="null" selected disabled hidden>
                            Select option
                          </option>
                          <option
                            v-for="country in countriesOnly"
                            :key="country.id"
                            :value="country.id"
                          >
                            {{ country.name }}
                          </option>
                        </select>
                      </div>
                      <i class="icon-material-outline-location-on"></i>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4" v-if="!isRemote">
                  <div class="submit-field">
                    <h5>Region</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select
                          title="Select Project Model"
                          v-model="projectRequest.region_id"
                          @change="getRegionId($event)"
                        >
                          <option :value="null" selected disabled hidden>
                            Select option
                          </option>
                          <option
                            v-for="region in regions"
                            :key="region.id"
                            :value="region.id"
                          >
                            {{ region.name }}
                          </option>
                        </select>
                      </div>
                      <i class="icon-material-outline-location-on"></i>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4" v-if="!isRemote">
                  <div class="submit-field">
                    <h5>City</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select
                          title="Select Project Model"
                          v-model="projectRequest.city_id"
                        >
                          <option :value="null" selected disabled hidden>
                            Select option
                          </option>
                          <option
                            v-for="city in cities"
                            :key="city.id"
                            :value="city.id"
                          >
                            {{ city.name }}
                          </option>
                        </select>
                      </div>
                      <i class="icon-material-outline-location-on"></i>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4" v-if="!isRemote">
                  <div class="submit-field">
                    <h5>Address</h5>
                    <div class="keywords-container">
                      <div class="keyword-input-container">
                        <input
                          type="text"
                          class="keyword-input with-border"
                          placeholder="12, Rolag Crescent, Ajah"
                          v-model="projectRequest.address"
                        />
                      </div>
                      <div class="keywords-list"><!-- keywords go here --></div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Experience Level</h5>
                    <div class="input-with-icon">
                      <div class="select__custom">
                        <select
                          title="Select Project Model"
                          v-model="projectRequest.experience"
                        >
                          <option :value="null" selected disabled hidden>
                            Select option
                          </option>
                          <option
                            v-for="(option, index) in expertise"
                            :key="index"
                            :value="index"
                          >
                            {{ option }}
                          </option>
                        </select>
                      </div>
                      <i class="icon-feather-chevron-down"></i>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Budget</h5>
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="input-with-icon">
                          <input
                            class="with-border"
                            type="text"
                            placeholder="Budget"
                            v-model="projectRequest.budget"
                          />
                          <i class="currency">NGN</i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>
                      Tags <span>(optional)</span>
                      <i
                        class="help-icon"
                        data-tippy-placement="right"
                        title="Maximum of 10 tags"
                      ></i>
                    </h5>
                    <div class="keywords-container">
                      <div class="keyword-input-container">
                        <input
                          type="text"
                          class="keyword-input with-border"
                          placeholder="e.g. job title, responsibilites"
                        />
                        <button class="keyword-input-button ripple-effect">
                          <i class="icon-material-outline-add"></i>
                        </button>
                      </div>
                      <div class="keywords-list"><!-- keywords go here --></div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Proposed Start Date</h5>
                    <div class="keywords-container">
                      <div class="keyword-input-container">
                        <input
                          v-model="projectRequest.proposed_start_date"
                          type="date"
                          class="keyword-input with-border"
                          placeholder=""
                        />
                      </div>
                      <div class="keywords-list"><!-- keywords go here --></div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4">
                  <div class="submit-field">
                    <h5>Duration of Project</h5>
                    <div class="keywords-container">
                      <div class="keyword-input-container">
                        <input
                          type="text"
                          class="keyword-input with-border"
                          placeholder="2 months"
                          v-model="projectRequest.duration"
                        />
                      </div>
                      <div class="keywords-list"><!-- keywords go here --></div>
                      <div class="clearfix"></div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-12">
                  <div class="submit-field">
                    <h5>Job Description</h5>
                    <textarea
                      cols="30"
                      rows="5"
                      class="with-border"
                      v-model="projectRequest.description"
                    ></textarea>
                    
                  </div>
                </div>
              </div>
            </div>
</keep-alive>
          </div>
        </div>

        <div class="col-xl-12">
          <a
            href="#"
            class="button ripple-effect big margin-top-30"
            @click="createProject(projectRequest)"
            ><i class="icon-feather-plus"></i> Post a Job</a
          >
        </div>
      </div>
      <!-- Row / End -->

      <!-- Row -->

      <!-- Row / End -->

      <app-footer></app-footer>
    </div>
  </div>
  <!-- Dashboard Content / End -->
</template>

<script>
/* eslint-disable no-console */
import { AppFooter } from "../../partials/user-dashboard";
import { getCall, postCall } from "../../../core/services/http.service";
import { ALL_TASKS_AND_SUBTASKS } from "../../../core/config/endpoints/tasks";
import { INITIATE_PROJECT_PAYMENT } from "../../../core/config/endpoints/project-payment";
//import { ATTACH_MEDIA_TO_PROJECT } from "../../../core/config/endpoints/project-media";
import {
  COUNTRIES,
  GET_REGION_WITH_COUNTRY_ID,
  GET_CITIES_WITH_REGION_ID,
} from "../../../core/config/endpoints/location";
import {
  PROJECT_ATTRIBUTES,
  CREATE_PROJECT,
} from "../../../core/config/endpoints/projects";

export default {
  name: "CreateProject",
  components: {
    AppFooter,
  },
  data() {
    return {
      expertise: {},
      status: [],
      models: {},
      numOfTaskMasters: [],
      tasks: [],
      countriesOnly: [],
      regions: [],
      cities: [],
      countryId: null,
      isRemote: false,
      regionId: null,
     
      projectRequest: {
        model: 0, //
        task_id: 0, //
        num_of_taskMaster: 0, //
        budget: 0, //
        experience: 0, //
        proposed_start_date: "",
        description: "",
        title: "", //
        sub_task_id: 0,
        country_id: 0,
        city_id: 0,
        region_id: 0,
        duration: 0,
      },
    };
  },
  computed: {},
  created() {
    this.getProjectAttributes();
    this.getAllTasks();
    this.getAllCountries();
    //this.getAllRegions()
  },
  methods: {
    createProject(request) {
      Object.values(this.projectRequest).every((value) => {
        if (value === 0 || value === "") {
          return this.$toast.error(`Please fill all the fields`);
        } else {
          this.projectRequest.budget = parseFloat(
            this.projectRequest.budget.replace(/,/g, "") 
          );
          this.projectRequest.experience = Number(
            this.projectRequest.experience
          );
          this.projectRequest.model = Number(this.projectRequest.model);
          this.$store.commit("setIsLoaded", true);
          postCall(CREATE_PROJECT, request)
            .then((response) => {
              if (response.status === 200) {
                console.log(response)
               this.$router.push({ path: '/dashboard/jobs/draftprojects' })
              } else {
                console.log("there is an error somewhere");
              }
            })
            .catch((error) => {
              this.$toast.error(`${error.response.data.message}`);
            })
            .finally(() => {
              this.$store.commit("setIsLoaded", false);
            });
        }

        return false;
      });
    },

    uploadFile() {
      console.log(this.$refs.file.files[0]);
      this.projectFormData.attachment.push(this.$refs.file.files[0]);
      // console.log(this.file)
    },
    getProjectAttributes() {
      getCall(PROJECT_ATTRIBUTES)
        .then((response) => {
          this.expertise = response.data.data.expertise;
          this.status = response.data.data.status;
          this.models = response.data.data.model;
          this.numOfTaskMasters = response.data.data.numOfTaskMasters;
        })
        .catch((error) => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },

    getAllTasks() {
      this.$store.commit("setIsLoaded", true);
      getCall(ALL_TASKS_AND_SUBTASKS)
        .then((response) => {
          this.tasks = response.data.data;
          this.tasks.sort((a, b) => a.name.localeCompare(b.name));
        })
        .catch((error) => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },

    getSubTasks() {},
    getAllCountries() {
      this.$store.commit("setIsLoaded", true);
      getCall(COUNTRIES)
        .then((response) => {
          this.countriesOnly = response.data.data;
        })
        .catch((error) => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },

    getAllRegions() {
      this.$store.commit("setIsLoaded", true);
      getCall(GET_REGION_WITH_COUNTRY_ID.COUNTRY_ID(this.countryId))
        .then((response) => {
          this.regions = response.data.data;
        })
        .catch((error) => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
    getAllCities() {
      this.$store.commit("setIsLoaded", true);
      getCall(GET_CITIES_WITH_REGION_ID.REGION_ID(this.regionId))
        .then((response) => {
          this.cities = response.data.data;
        })
        .catch((error) => {
          this.$toast.error(`${error.response.data.message}`);
        })
        .finally(() => {
          this.$store.commit("setIsLoaded", false);
        });
    },
    getCountryId(e) {
      let id = e.target.value;
      this.countryId = id;
      this.getAllRegions();
    },
    getRegionId(e) {
      let id = e.target.value;
      this.regionId = id;
      this.getAllCities();
    },
    changeModel(e) {
      let id = e.target.value;
      if (id == "01") {
        this.isRemote = true;
      } else {
        this.isRemote = false;
      }
    },
  },
};
</script>

<style></style>
